import { render, staticRenderFns } from "./DownloadCenterList.vue?vue&type=template&id=235196a8&"
import script from "./DownloadCenterList.vue?vue&type=script&lang=js&"
export * from "./DownloadCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports